const LEGACY_DURATION_KEY = 'meta.Duration';
const DURATION_KEY = 'duration';
const LEGACY_DURATION_OPERATOR_KEY = 'meta.DurationOperator';
const DURATION_OPERATOR_KEY = 'durationOperator';

export function remapDurationSortType(sort) {
  if (!sort || sort.type !== LEGACY_DURATION_KEY) return sort;

  return { ...sort, type: DURATION_KEY };
}

export default function remapDurationSearchProps(params) {
  if (!params || typeof params !== 'object') return params;

  if (params[LEGACY_DURATION_KEY] !== undefined && params[DURATION_KEY] === undefined) {
    params[DURATION_KEY] = params[LEGACY_DURATION_KEY];
  }
  delete params[LEGACY_DURATION_KEY];

  if (params[LEGACY_DURATION_OPERATOR_KEY] !== undefined && params[DURATION_OPERATOR_KEY] === undefined) {
    params[DURATION_OPERATOR_KEY] = params[LEGACY_DURATION_OPERATOR_KEY];
  }
  delete params[LEGACY_DURATION_OPERATOR_KEY];

  if (params.operators && typeof params.operators === 'object') {
    if (params.operators[LEGACY_DURATION_KEY] !== undefined && params.operators[DURATION_KEY] === undefined) {
      params.operators[DURATION_KEY] = params.operators[LEGACY_DURATION_KEY];
    }
    delete params.operators[LEGACY_DURATION_KEY];
  }

  if (params.sort) {
    params.sort = remapDurationSortType(params.sort);
  }

  return params;
}
